import React, { useState, useEffect, useContext } from "react";
import {
  useTheme,
  useMediaQuery,
  Tooltip,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../Auth/Context";
import { Typography, Stack } from "@mui/material";
import CardComponent from "../atoms/CardComponent";
import ButtonComponent from "../atoms/ButtonComponent";
import useWexClient from "../../hooks/Clients/wexClient,";
import CircularProgressBar from "../atoms/Downloader";
import stylesLoader from "./../../styles/Molecules/Loader/Loader";
import stylesServices from "../../styles/Molecules/Servicios/services";
import stylesAgent from "../../styles/Molecules/Agents/styleAgents";
import AlertComponent from "../atoms/Alert";
import MuiModal from "../atoms/MuiModal";
import InputLabelC from "../atoms/InputLabel";
import InputCheckboxes from "../atoms/InputCheckboxes";
import selectCircle from "../atoms/RadioButton";
import useClass from "../../hooks/useClass";
import TableLine from "../atoms/TableLine";
import { useTranslation } from "react-i18next";
import "../../Traduccion_ES_EN/i18nMiCuenta";
import { usePermissions } from "../../hooks/usePermissions";
import useShifts from "../../hooks/useShifts";
import InputTime from "../atoms/InputTime";
import { Circle } from "@mui/icons-material";
import SwitchComponent from "../atoms/SwitchControler";
import ModalCampaigns from "../../views/OptionDashboard/Modals/ModalCampaigns";
import ButtonFile from "../atoms/ButtonFile";

function Servicios() {
  const { id } = useParams();
  const { payload } = useContext(AuthContext);
  const { t } = useTranslation();
  const { can } = usePermissions(payload);
  //========================================
  //PERMISOS
  //========================================
  // REGION
  const canReadRegion = can("read", "region");
  const canCreateRegion = can("create", "region");
  const canUpdateRegion = can("update", "region");
  const canDeleteRegion = can("delete", "region");
  //CLASS
  const canCreateClassification = can("create", "classification");
  const canReadClassification = can("read", "classification");
  const canUpdateClassification = can("update", "classification");
  const canDeleteClassification = can("delete", "classification");
  //ENCUESTAS
  const canReadSurvey = can("read", "surveys");
  const canCreateSurvey = can("create", "surveys");
  const canUpdateSurvey = can("update", "surveys");
  const canDeleteSurvey = can("delete", "surveys");
  // TURNOS
  const canReadShift = can("read", "shifts");
  const canUpdateShift = can("update", "shifts");
  const canDeleteShift = can("delete", "shifts");
  const canCreateShift = can("create", "shifts");

  const {
    getClassifications,
    getDeleteClass,
    getRegions,
    updateRegions,

    createRegions,
    createSurvey,
    getSurveys,
    updateSurvey,
    deleteSurvey, // Pendientes de backend
  } = useWexClient();
  const { createNewClass } = useClass();
  const { createNewShift, getShiftsByService, updateShift } = useShifts();

  const theme = useTheme();
  const isScreenResponsive = useMediaQuery(theme.breakpoints.up("lg"));
  const [isLoading, setIsLoading] = useState(true);
  //Alerts
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertError, setShowAlertError] = useState(false);
  const [messageAlertError, setMessageAlertError] = useState("");
  const [typeAlertError, setTypeAlertError] = useState("error");
  const [messageAlert, setMessageAlert] = useState("");
  const [typeAlert, setTypeAlert] = useState("success");
  const [itemToDelete, setItemToDelete] = useState(null);
  const [modalVisibleDelete, setModalVisibleDelete] = useState(false);
  //clasificaciones
  const [dataClass, setDataClass] = useState(null);
  const columnTitlesClass = ["Clasificación", "Tipo de clasificación"];
  const [modalVisibleAddClass, setModalVisibleAddClass] = useState(false);
  const [typeClass, setTypeClass] = useState("");
  const [name, setName] = useState("");
  //region
  const [modalVisibleUpdateRegion, setModalVisibleUpdateRegion] =
    useState(false);
  const [modalVisibleAddRegion, setModalVisibleAddRegion] = useState(false); // Define new state for add region modal
  const [nameRegion, setNameRegion] = useState("");
  const [status, setStatus] = useState(true);
  const [dataRegion, setDataRegion] = useState(null);
  //Shifts
  const [dataShifts, setDataShifts] = useState([]);
  const [modalVisibleAddShift, setModalVisibleAddShift] = useState(false);
  const [modalVisibleEditShift, setModalVisibleEditShift] = useState(false);
  const [nameShift, setNameShift] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [shiftsDays, setShiftsDays] = useState([]);
  const [selectedShift, setSelectedShift] = useState(null);
  const [shiftActive, setShiftActive] = useState(true);
  //SURVEYS
  const [modalVisibleAddSurvey, setModalVisibleAddSurvey] = useState(false);
  const [surveyName, setSurveyName] = useState("");
  const [questions, setQuestions] = useState([
    { text: "", type: "options", options: [""] },
  ]);
  const [isEditingSurv, setIsEditingSurv] = useState(false);
  const [dataSurveys, setDataSurveys] = useState([]);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [modalViewSurvey, setModalViewSurvey] = useState(false);

  // IMPORTACION DE TURNOS
  const [openModalCampaigns, setOpenModalCampaigns] = useState(false);
  const [fileToImport, setFileToImport] = useState(null);
  const [fileNameToImport, setFileNameToImport] = useState("");
  const [rowsToImport, setRowsToImport] = useState([]);
  const [columnsToImport, setColumnsToImport] = useState([]);

  const optionsStatus = [
    { label: "Activo", value: true },
    { label: "Inactivo", value: false },
  ];

  const optionsClass = [
    { label: "Rechazados", value: "_REJECTS_" },
    { label: "Siniestros", value: "_VISITS_" },
    { label: "Cancelados", value: "_CANCELED_" },
  ];
  const allowedByAgent = {
    _ADJUSTER_: ["_REJECTS_", "_VISITS_", "_CANCELED_"],
  };
  const typeAgent = payload?.profile?.typeAgent;
  const role = payload?.profile?.class;

  const filteredOptionsClass =
    role === "_ADMIN_"
      ? optionsClass
      : optionsClass.filter((option) =>
          (allowedByAgent[typeAgent] || []).includes(option.value),
        );

  const handleClickAddRegion = () => {
    setNameRegion("");
    setStatus(true);
    setModalVisibleAddRegion(true); // Open the correct modal for adding
  };

  const handleCloseModalUpdateRegion = () => {
    setModalVisibleUpdateRegion(false);
  };

  const handleCloseModalAddRegion = () => {
    // Defined this function
    setModalVisibleAddRegion(false);
    setNameRegion("");
    setStatus(true);
  };

  // SURVEYS HANDLERS

  const fetchDataSurveys = async () => {
    try {
      const serviceId = id || payload.service;
      const response = await getSurveys(serviceId);

      if (response?.success === false) {
        setDataSurveys(response.message || "Error al cargar encuestas");
        return;
      }

      if (response?.success === true) {
        const data = response.data;
        const normalized = Array.isArray(data) ? data : data ? [data] : [];
        // Filtrar preguntas con status true
        const surveyFilteredQuestions = normalized.map((survey) => ({
          ...survey,
          questions: survey.questions
            ? survey.questions.filter((q) => q.status !== false)
            : [],
        }));
        setDataSurveys(surveyFilteredQuestions);
      }
    } catch (error) {
      console.error("Error fetching surveys:", error);
      setDataSurveys("Error de conexión al cargar encuestas");
    }
  };

  const handleClickAddSurvey = () => {
    if (!canCreateSurvey) {
      setMessageAlertError("No tienes permisos para crear encuestas");
      setShowAlertError(true);
      return;
    }
    setSurveyName("");
    setQuestions([{ text: "", type: "options", options: [""] }]);
    setModalVisibleAddSurvey(true);
  };

  const handleCloseModalAddSurvey = () => {
    setModalVisibleAddSurvey(false);
    setSurveyName("");
    setQuestions([{ text: "", type: "options", options: [""] }]);
  };

  const handleAddQuestion = () => {
    setQuestions([...questions, { text: "", type: "options", options: [""] }]);
  };

  const handleRemoveQuestion = (index) => {
    const newQuestions = [...questions];

    if (newQuestions[index]._id) {
      newQuestions[index].isDeleted = true;
    } else {
      newQuestions.splice(index, 1);
    }

    setQuestions(newQuestions);
  };

  const buildSurveyPayload = () => {
    const add = [];
    const update = [];
    const remove = [];

    questions.forEach((q) => {
      if (q.isDeleted && q._id) {
        remove.push(q._id);
      } else if (!q._id) {
        add.push({
          text: q.text,
          type: q.type,
          ...(q.type === "options" && { options: q.options }),
          required: true,
        });
      } else {
        update.push({
          id: q._id,
          text: q.text,
          status: true,
        });
      }
    });

    const body = {};
    if (add.length) body.add = add;
    if (update.length) body.update = update;
    if (remove.length) body.remove = remove;

    return body;
  };

  const handleQuestionChange = (index, field, value) => {
    const newQuestions = [...questions];
    newQuestions[index][field] = value;
    setQuestions(newQuestions);
  };

  const handleAddOption = (questionIndex) => {
    const newQuestions = [...questions];
    newQuestions[questionIndex].options.push("");
    setQuestions(newQuestions);
  };

  const handleRemoveOption = (questionIndex, optionIndex) => {
    const newQuestions = [...questions];
    newQuestions[questionIndex].options = newQuestions[
      questionIndex
    ].options.filter((_, i) => i !== optionIndex);
    setQuestions(newQuestions);
  };

  const handleOptionChange = (questionIndex, optionIndex, value) => {
    const newQuestions = [...questions];
    newQuestions[questionIndex].options[optionIndex] = value;
    setQuestions(newQuestions);
  };

  const handleCreateSurvey = async () => {
    if (!surveyName.trim()) {
      setMessageAlertError("El nombre de la encuesta es obligatorio");
      setShowAlertError(true);
      return;
    }

    if (questions.some((q) => !q.text.trim())) {
      setMessageAlertError("Todas las preguntas deben tener texto");
      setShowAlertError(true);
      return;
    }

    if (
      questions.some(
        (q) => q.type === "options" && q.options.some((o) => !o.trim()),
      )
    ) {
      setMessageAlertError("Todas las opciones deben tener texto");
      setShowAlertError(true);
      return;
    }

    try {
      const surveyData = {
        name: surveyName.trim(),
        service: id,
        questions: questions.map((q) => ({
          text: q.text.trim(),
          type: q.type,
          ...(q.type === "options" && {
            options: q.options.filter((o) => o.trim()),
          }),
        })),
      };

      const response = await createSurvey(surveyData);

      if (response?.success === true || response?.data) {
        setMessageAlert("Encuesta creada exitosamente");
        setTypeAlert("success");
        setShowAlert(true);

        await fetchDataSurveys();

        setTimeout(() => {
          setShowAlert(false);
          handleCloseModalAddSurvey();
        }, 2000);
      } else {
        setMessageAlertError(response?.message || "Error al crear la encuesta");
        setShowAlertError(true);
      }
    } catch (err) {
      console.error(err);
      setMessageAlertError("Error de conexión");
      setShowAlertError(true);
    }
  };

  const cardWidth = isScreenResponsive ? "95%" : "100%";
  const buttonWidth = isScreenResponsive ? "30%" : "100%";
  const modalWidth = isScreenResponsive ? "28rem" : "90%";

  const fetchDataAndUpdateTable = () => {
    getClassifications().then((response) => {
      if (response?.success === false) {
        setDataClass(response.message || "Error al cargar clasificaciones");
        setIsLoading(false);
        return;
      }

      const classifications = Array.isArray(response)
        ? response
        : response?.data || [];

      if (!Array.isArray(classifications)) {
        setDataClass([]);
        setIsLoading(false);
        return;
      }
      const role = payload?.profile?.class;
      const typeAgent = payload?.profile?.typeAgent;

      // ✅ ADMIN ve TODO
      if (role === "_ADMIN_") {
        setDataClass(classifications);
        setIsLoading(false);
        return;
      }

      const allowedTypes = allowedByAgent[typeAgent] || [];

      const filteredData = classifications.filter((item) =>
        allowedTypes.includes(item.typeUse),
      );

      setDataClass(filteredData);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    fetchDataAndUpdateTable();
  }, []);

  const handleClickTrashClose = () => {
    setModalVisibleDelete(false);
  };

  const handleClick = () => {
    setModalVisibleAddClass(true);
  };

  const handleCloseModalAddClass = () => {
    setShowAlert(false);
    setShowAlertError(false);
    setName("");
    setModalVisibleAddClass(false);
  };

  const deleteClass = (body) => {
    if (!canDeleteClassification) {
      setMessageAlertError("No tienes permisos para eliminar clasificaciones");
      setShowAlertError(true);
      return;
    }
    getDeleteClass(body)
      .then(() => {
        fetchDataAndUpdateTable();
      })
      .catch((error) => {
        console.error("error", error.message);
      });
  };

  const confirmDeleteClass = () => {
    const body = {
      idClassification: itemToDelete._id,
    };
    deleteClass(body);
    setModalVisibleDelete(false);
  };

  const handleDeleteClick = (item) => {
    setModalVisibleDelete(true);
    setItemToDelete(item);
  };

  const handleModalAddClass = async () => {
    if (!name.trim()) {
      setMessageAlertError("Campo vacío");
      setShowAlertError(true);

      setTimeout(() => {
        setShowAlertError(false);
      }, 2000);

      return;
    }
    if (!canCreateClassification) {
      setMessageAlertError("No tienes permisos para crear clasificaciones");
      setShowAlertError(true);
      return;
    }
    try {
      const object = {
        name,
        typeUse: typeClass,
      };

      const response = await createNewClass(object);

      if (response?.success === true) {
        // success esta mal escrito
        setMessageAlert(response?.message);
        setTypeAlert("success");
        setShowAlert(true);

        fetchDataAndUpdateTable();

        setTimeout(() => {
          setShowAlert(false);
          handleCloseModalAddClass();
        }, 3000);
      }

      if (response?.success === false) {
        // success esta mal escrito
        setMessageAlertError(response?.message);
        setTypeAlertError("error");
        setShowAlertError(true);

        setTimeout(() => {
          setShowAlertError(false);
        }, 3000);
      }
    } catch (err) {
      console.error(err);

      setMessageAlertError("Error de conexión");
      setTypeAlertError("error");
      setShowAlertError(true);

      setTimeout(() => {
        setShowAlertError(false);
      }, 2000);
    }
  };

  const columnTitlesRegion = ["Región", "Status"];
  const fetchDataRegion = async () => {
    try {
      const body = { idService: id };
      const response = await getRegions(body);

      if (response?.success === false) {
        setDataRegion(response.message || "Error al cargar regiones");
        return;
      }

      if (response?.success === true) {
        setDataRegion(response.data);
        return;
      }
    } catch (error) {
      console.error("Error fetching regions:", error);
      setDataRegion("Error de conexión al cargar regiones");
    }
  };

  const handleEditClick = (item, e) => {
    e.preventDefault(); // evita salto al top por href="#"
    setNameRegion(item.name);
    setStatus(item.status);
    setItemToDelete(item);
    setModalVisibleUpdateRegion(true);
  };

  const handleTextChangeNameRegion = (text) => {
    setNameRegion(text);
  };

  const handleUpdateRegion = async () => {
    if (!canUpdateRegion) {
      setMessageAlertError("No tienes permisos para editar regiones");
      setShowAlertError(true);
      return;
    }
    try {
      setShowAlert(false);
      setShowAlertError(false);
      const idRegion = itemToDelete?._id;
      if (!idRegion) {
        setMessageAlertError("No se encontró el ID de la región.");
        setShowAlertError(true);
        return;
      }
      const body = {};
      if (nameRegion?.trim()) body.name = nameRegion.trim();
      if (status !== null && status !== undefined) body.status = status;

      if (Object.keys(body).length === 0) {
        setMessageAlertError("No hay cambios para actualizar.");
        setShowAlertError(true);
        return;
      }
      const response = await updateRegions(idRegion, body);

      if (response?.success === true) {
        setMessageAlert(response?.message);
        setTypeAlert("success");
        setShowAlert(true);
        setShowAlertError(false);
        await fetchDataRegion();

        setTimeout(() => {
          setShowAlert(false);
          handleCloseModalUpdateRegion();
        }, 2500);
      } else {
        setMessageAlertError(response?.message);
        setShowAlertError(true);
        setTypeAlertError("error");
      }
    } catch (err) {
      console.error(err);
      setMessageAlertError("Error de conexión");
      setShowAlertError(true);
    }
  };

  const handleAddRegion = async () => {
    if (!canCreateRegion) {
      setMessageAlertError("No tienes permisos para crear regiones");
      setShowAlertError(true);
      return;
    }
    try {
      if (!nameRegion?.trim()) {
        setMessageAlertError("El nombre es obligatorio.");
        setShowAlertError(true);
        return;
      }

      const body = {
        name: nameRegion.trim(),
        service: id,
      };

      const response = await createRegions(body);

      if (response?.success === true) {
        setMessageAlert(response?.message || "Región creada");
        setTypeAlert("success");
        setShowAlert(true);

        await fetchDataRegion();

        setTimeout(() => {
          setShowAlert(false);
          handleCloseModalAddRegion();
        }, 2000);
      } else {
        setMessageAlertError(response?.message || "No se pudo crear la región");
        setTypeAlertError("error");
        setShowAlertError(true);
      }
    } catch (err) {
      console.error(err);
      setMessageAlertError("Error de conexión");
      setShowAlertError(true);
    }
  };

  const handleUpdateSurvey = async () => {
    const body = buildSurveyPayload();
    await updateSurvey(selectedSurvey._id, body);
  };
  //********************* */
  //      Shifts / Turnos
  //********************* */
  const shiftsColumns = [
    "Turno",
    "Horario",
    "Dias",
    "Status",
    "Cambiar Status",
  ];

  const fetchDataShifts = async (idService) => {
    const res = await getShiftsByService(idService);

    if (res?.success === true) {
      setDataShifts(res.data);
    } else {
      console.error("Error al obtener turnos:", res?.message);
    }
  };

  const handleClickAddShift = () => {
    if (!canCreateShift) {
      setMessageAlertError("No tienes permisos para crear turnos");

      return;
    }
    setModalVisibleAddShift(true);
    setShowAlertError(false);
    setShowAlert(false);
  };

  const handleCloseModalShifts = () => {
    // Limpiar alertas al cerrar modal de edición
    setShowAlert(false);
    setShowAlertError(false);
    setMessageAlert("");
    setMessageAlertError("");
    setModalVisibleEditShift(false);
  };

  const handleOpenModalShifts = (shift) => {
    setSelectedShift(shift);

    setNameShift(shift.name || "");
    setStartTime(shift.startTime || "");
    setEndTime(shift.endTime || "");
    // Usar daysArray prioritariamente para evitar el error de string fragmentado
    setShiftsDays(Array.isArray(shift.daysArray) ? shift.daysArray : []);

    setShowAlert(false);
    setShowAlertError(false);

    setModalVisibleEditShift(true);
  };

  const createNewShiftForService = async () => {
    try {
      if (!nameShift.trim()) {
        setMessageAlertError("El nombre del turno es obligatorio");
        setShowAlertError(true);
        return;
      }

      if (!startTime || !endTime) {
        setMessageAlertError("Debes seleccionar horario");
        setShowAlertError(true);
        return;
      }

      if (shiftsDays.length === 0) {
        setMessageAlertError("Selecciona al menos un día");
        setShowAlertError(true);
        return;
      }

      const body = {
        name: nameShift.trim(),
        service: id,
        startTime,
        endTime,
        days: shiftsDays,
      };

      const res = await createNewShift(body);

      if (res?.success === true) {
        setMessageAlert(res.message);
        setTypeAlert("success");
        setShowAlert(true);

        await fetchDataShifts(id);

        setTimeout(() => {
          setModalVisibleAddShift(false);

          setNameShift("");
          setStartTime("");
          setEndTime("");
          setShiftsDays([]);

          setShowAlert(false);
        }, 2000);
      } else {
        setMessageAlertError(res?.message || "Error al crear turno");
        setShowAlertError(true);
      }
    } catch (error) {
      console.error(error);

      setMessageAlertError("Error de conexión");
      setShowAlertError(true);
    }
  };

  const handleUpdateShift = async () => {
    try {
      if (!selectedShift?.id) {
        setMessageAlertError("No se encontró el turno");
        setShowAlertError(true);
        return;
      }

      if (!nameShift.trim()) {
        setMessageAlertError("El nombre del turno es obligatorio");
        setShowAlertError(true);
        return;
      }

      if (!startTime || !endTime) {
        setMessageAlertError("Debes seleccionar horario");
        setShowAlertError(true);
        return;
      }

      if (shiftsDays.length === 0) {
        setMessageAlertError("Selecciona al menos un día");
        setShowAlertError(true);
        return;
      }

      const body = {
        id: selectedShift.id,
        name: nameShift.trim(),
        startTime,
        endTime,
        days: shiftsDays,
        status: selectedShift.status,
      };

      const response = await updateShift(body);

      if (response?.success === true) {
        setMessageAlert(response.message || "Turno actualizado");
        setTypeAlert("success");
        setShowAlert(true);

        await fetchDataShifts(id);

        setTimeout(() => {
          setModalVisibleEditShift(false);

          setSelectedShift(null);
          setNameShift("");
          setStartTime("");
          setEndTime("");
          setShiftsDays([]);

          setShowAlert(false);
        }, 2000);
      } else {
        setMessageAlertError(response?.message || "Error al actualizar");
        setShowAlertError(true);
      }
    } catch (error) {
      console.error(error);

      setMessageAlertError("Error de conexión");
      setShowAlertError(true);
    }
  };

  const handleToggleShiftStatus = async (shift) => {
    try {
      const body = {
        id: shift.id,
        name: shift.name,
        startTime: shift.startTime,
        endTime: shift.endTime,
        days: Array.isArray(shift.daysArray) ? shift.daysArray : [],
        status: !shift.status,
      };

      const response = await updateShift(body);

      if (response?.success === true) {
        setDataShifts((prev) =>
          prev.map((item) =>
            item.id === shift.id ? { ...item, status: !item.status } : item,
          ),
        );

        setMessageAlert(response.message || "Turno actualizado");
        setTypeAlert("success");
        setShowAlert(true);

        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
      } else {
        setMessageAlertError(response?.message || "Error al actualizar turno");
        setShowAlertError(true);
      }
    } catch (error) {
      console.error(error);

      setMessageAlertError("Error de conexión");
      setShowAlertError(true);
    }
  };

  useEffect(() => {
    if (!id) return;

    fetchDataShifts(id);
    fetchDataRegion();
    fetchDataSurveys();
  }, [id]);

  // LOGICA PARA IMPORTAR TURNOS (CSV)
  const handleFileChange = (target) => {
    const file = target.files[0];
    if (!file) return;

    setFileToImport(file);
    setFileNameToImport(file.name);

    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      // Parseo básico de CSV
      const rows = text
        .split("\n")
        .map((row) => row.split(",").map((cell) => cell.trim()));
      const headers = rows[0];
      const data = rows
        .slice(1)
        .filter((r) => r.length > 1 || (r.length === 1 && r[0] !== ""));

      setColumnsToImport(headers);
      setRowsToImport(data);
      setOpenModalCampaigns(true);
    };
    reader.readAsText(file);
  };

  //******************** */
  //      Buttons
  //******************** */

  const ButtonsUpdateRegion = () => (
    <>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={"Actualizar Región"}
          onClick={handleUpdateRegion}
          backgroundColor="#1976d2"
          color="white"
        />
      </div>
    </>
  );

  const ButtonsAddRegion = () => (
    <div style={stylesAgent.divButton}>
      <ButtonComponent
        label="Agregar Región"
        onClick={handleAddRegion}
        backgroundColor="#1976d2"
        color="white"
      />
    </div>
  );

  if (isLoading) {
    return (
      <div style={stylesLoader.containerLoader}>
        <CircularProgressBar />
      </div>
    );
  }

  const ButtonsClass = () => (
    <>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={t("Welcome.text25")}
          onClick={handleCloseModalAddClass}
          backgroundColor="#9a2edb"
          color="white"
        />
      </div>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={t("Welcome.text24")}
          onClick={handleModalAddClass}
          backgroundColor="#1976d2"
        />
      </div>
    </>
  );

  const ButtonDelete = () => (
    <>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={t("Welcome.text119")}
          onClick={confirmDeleteClass}
          backgroundColor="#9f0202"
          color="white"
        />
      </div>
    </>
  );

  const ButtonsShifts = () => (
    <>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={t("Welcome.text25")}
          onClick={() => setModalVisibleAddShift(false)}
          backgroundColor="#9a2edb"
          color="white"
        />
      </div>

      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={t("Welcome.text24")}
          onClick={createNewShiftForService}
          backgroundColor="#1976d2"
        />
      </div>
    </>
  );

  const ButtonsEdiShifts = () => (
    <>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={t("Welcome.text25")}
          onClick={handleCloseModalShifts}
          backgroundColor="#9a2edb"
          color="white"
        />
      </div>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={t("Welcome.text24")}
          onClick={handleUpdateShift}
          backgroundColor="#1976d2"
        />
      </div>
    </>
  );

  //********************* */
  //  Cell Renderers
  //********************* */

  function cellRendererClass(classItem, title) {
    const typeUseToLabel = {
      _REJECTS_: "Rechazados",
      _VISITS_: "Siniestros",
      _CANCELED_: "Cancelados",
    };
    return (
      <div style={{ fontFamily: "Raleway, sans-serif", fontSize: "14px" }}>
        {title === "Clasificación"
          ? classItem.name
          : title === "Tipo de clasificación"
            ? typeUseToLabel[classItem.typeUse] || classItem.typeUse
            : null}
      </div>
    );
  }

  function cellRendererRegion(regionItem, title) {
    return (
      <div style={{ fontFamily: "Raleway, sans-serif", fontSize: "14px" }}>
        {title === "Región"
          ? regionItem.name
          : title === "Status"
            ? regionItem.status
              ? "Activo"
              : "Inactivo"
            : null}
      </div>
    );
  }

  function cellRendererSurvey(surveyItem, title) {
    const key = title?.toLowerCase();
    return (
      <div style={{ fontFamily: "Raleway, sans-serif", fontSize: "14px" }}>
        {key === "nombre"
          ? surveyItem.name
          : key === "preguntas"
            ? (surveyItem.questions?.filter((q) => q.status !== false) || [])
                .length
            : null}
      </div>
    );
  }

  function cellRendererShift(shifts, title) {
    return (
      <div style={{ fontFamily: "Raleway, sans-serif", fontSize: "14px" }}>
        {title === "Turno" ? (
          shifts.name
        ) : title === "Horario" ? (
          shifts.schedule || `${shifts.startTime} - ${shifts.endTime}`
        ) : title === "Dias" ? (
          Array.isArray(shifts.days) ? (
            shifts.days.join(", ")
          ) : (
            shifts.days
          )
        ) : title === "Status" ? (
          <Tooltip title={shifts.status ? "Activo" : "Inactivo"} arrow>
            <Circle
              sx={{
                fontSize: 20,
                color: shifts.status ? "#8db600" : "#c20000",
              }}
            />
          </Tooltip>
        ) : title === "Cambiar Status" ? (
          <SwitchComponent
            checked={shifts.status}
            onChange={() => handleToggleShiftStatus(shifts)}
          />
        ) : null}
      </div>
    );
  }

  return (
    <Stack>
      <Stack style={{ ...stylesServices.divb, marginTop: "-2rem" }}>
        <Typography variant="h4" style={stylesServices.typography}>
          {t("Welcome.text46")}
        </Typography>

        <Stack direction="column" spacing={2}>
          <Stack
            direction={isScreenResponsive ? "row" : "column"}
            spacing={2}
            style={isScreenResponsive ? stylesServices.divc : {}}
            justifyContent="space-between"
          >
            {/* CLASIFICACIONES */}
            <div
              style={{
                ...stylesServices.typographyb,
                flex: 1,
                minWidth: isScreenResponsive ? "48%" : "100%",
              }}
            >
              <CardComponent title={t("Welcome.text233")} color="#4c4c4c">
                <Stack
                  direction="row"
                  spacing="5rem"
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    width: "100%",
                  }}
                >
                  <Stack sx={{ width: cardWidth }}>
                    {typeof dataClass === "string" ? (
                      <p
                        style={{
                          fontFamily: "Raleway, sans-serif",
                          fontSize: "14px",
                          color: "red",
                        }}
                      >
                        {dataClass}
                      </p>
                    ) : (
                      <TableLine
                        data={dataClass}
                        columnTitles={columnTitlesClass}
                        cellComponent={cellRendererClass}
                        showDeleteColumn={canDeleteClassification}
                        handleDeleteClick={
                          canDeleteClassification
                            ? handleDeleteClick
                            : undefined
                        }
                      />
                    )}
                  </Stack>
                </Stack>
              </CardComponent>

              <div style={stylesServices.dive}>
                {canCreateClassification && (
                  <ButtonComponent
                    label={t("Welcome.text146")}
                    onClick={handleClick}
                    backgroundColor="#73c883"
                    width={buttonWidth}
                  />
                )}
              </div>
            </div>

            {
              /* REGIONES (solo visible para: Admin)*/ canReadRegion && (
                <div
                  style={{
                    ...stylesServices.typographyb,
                    flex: 1,
                    minWidth: isScreenResponsive ? "48%" : "100%",
                  }}
                >
                  <CardComponent title={t("Welcome.text301")} color="#4c4c4c">
                    <Stack
                      direction="row"
                      spacing="5rem"
                      style={{
                        maxHeight: "400px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        width: "100%",
                      }}
                    >
                      <Stack sx={{ width: cardWidth }}>
                        {typeof dataRegion === "string" ? (
                          <p
                            style={{
                              fontFamily: "Raleway, sans-serif",
                              fontSize: "14px",
                              color: "red",
                            }}
                          >
                            {dataRegion}
                          </p>
                        ) : (
                          <TableLine
                            data={dataRegion}
                            columnTitles={columnTitlesRegion}
                            cellComponent={cellRendererRegion}
                            showActionColumn={true}
                            actionColumnLabel="Editar"
                            onActionClick={handleEditClick}
                          />
                        )}
                      </Stack>
                    </Stack>
                  </CardComponent>

                  <div style={stylesServices.dive}>
                    <ButtonComponent
                      label={t("Welcome.text215")}
                      onClick={handleClickAddRegion}
                      backgroundColor="#73c883"
                      width={buttonWidth}
                    />
                  </div>
                </div>
              )
            }
          </Stack>
          <Stack
            direction={isScreenResponsive ? "row" : "column"}
            spacing={2}
            style={isScreenResponsive ? stylesServices.divc : {}}
            justifyContent="space-between"
          >
            {canReadSurvey && (
              <div
                style={{
                  ...stylesServices.typographyb,
                  flex: 1,
                  minWidth: isScreenResponsive ? "48%" : "100%",
                }}
              >
                <CardComponent title="Encuestas" color="#4c4c4c">
                  <Stack
                    direction="row"
                    spacing="5rem"
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      overflowX: "hidden",
                      width: "100%",
                    }}
                  >
                    <Stack sx={{ width: cardWidth }}>
                      {typeof dataSurveys === "string" ? (
                        <p
                          style={{
                            fontFamily: "Raleway, sans-serif",
                            fontSize: "14px",
                            color: "red",
                          }}
                        >
                          {dataSurveys}
                        </p>
                      ) : (
                        <TableLine
                          data={dataSurveys}
                          columnTitles={["Nombre", "Preguntas"]}
                          cellComponent={cellRendererSurvey}
                          showDeleteColumn={canDeleteSurvey}
                          handleDeleteClick={
                            canDeleteSurvey
                              ? (item) => {
                                  deleteSurvey(item._id);
                                  fetchDataSurveys();
                                }
                              : undefined
                          }
                          showActionColumn={true}
                          actionColumnLabel="Ver"
                          onActionClick={(item) => {
                            setSelectedSurvey(item);
                            // 👇 importante - Filtrar solo preguntas con status true
                            const filteredQuestions = (item.questions || [])
                              .filter((q) => q.status !== false)
                              .map((q) => ({
                                ...q,
                                isNew: false,
                                isDeleted: false,
                              }));
                            setQuestions(filteredQuestions);
                            setIsEditingSurv(false);
                            setModalViewSurvey(true);
                          }}
                        />
                      )}
                    </Stack>
                  </Stack>
                </CardComponent>

                <div style={stylesServices.dive}>
                  <Tooltip
                    title={
                      canCreateSurvey
                        ? ""
                        : "No tienes permiso para crear encuestas"
                    }
                  >
                    <span>
                      <ButtonComponent
                        label={t("Welcome.text146")}
                        onClick={handleClickAddSurvey}
                        backgroundColor={canCreateSurvey ? "#73c883" : "#ccc"}
                        disabled={!canCreateSurvey}
                        width={buttonWidth}
                        style={{
                          opacity: canCreateSurvey ? 1 : 0.5,
                          cursor: canCreateSurvey ? "pointer" : "not-allowed",
                        }}
                      />
                    </span>
                  </Tooltip>
                </div>
              </div>
            )}

            <div
              style={{
                ...stylesServices.typographyb,
                flex: 1,
                minWidth: isScreenResponsive ? "48%" : "100%",
              }}
            >
              <CardComponent title="Turnos" color="#4c4c4c">
                <Stack
                  direction="column"
                  alignItems="flex-end"
                  spacing={1}
                  sx={{ mb: 2 }}
                >
                  <ButtonFile
                    label="Asignar Turnos"
                    backgroundColor="#1976d2"
                    color="white"
                    setFile={handleFileChange}
                  />
                  <Typography variant="caption" sx={{ color: "gray" }}>
                    Sube un archivo CSV para asignar turnos masivamente
                  </Typography>
                </Stack>

                <Stack
                  direction="row"
                  spacing="5rem"
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    width: "100%",
                  }}
                >
                  <Stack sx={{ width: cardWidth }}>
                    {dataShifts.length === 0 ? (
                      <Typography>No hay turnos disponibles</Typography>
                    ) : (
                      <TableLine
                        data={dataShifts}
                        columnTitles={shiftsColumns}
                        cellComponent={cellRendererShift}
                        showActionColumn={true}
                        actionColumnLabel="Editar"
                        actionColumnTitle="Acciones"
                        onActionClick={handleOpenModalShifts}
                      />
                    )}
                  </Stack>
                </Stack>
              </CardComponent>

              <div style={stylesServices.dive}>
                <Tooltip
                  title={
                    canCreateShift ? "" : "No tienes permiso para crear Turnos"
                  }
                >
                  <span>
                    <ButtonComponent
                      label={t("Welcome.text146")}
                      onClick={handleClickAddShift}
                      backgroundColor={canCreateShift ? "#73c883" : "#ccc"}
                      disabled={!canCreateShift}
                      width={buttonWidth}
                      style={{
                        opacity: canCreateShift ? 1 : 0.5,
                        cursor: canCreateShift ? "pointer" : "not-allowed",
                      }}
                    />
                  </span>
                </Tooltip>
              </div>
            </div>
          </Stack>
        </Stack>
      </Stack>

      <ModalCampaigns
        open={openModalCampaigns}
        handleClose={() => setOpenModalCampaigns(false)}
        file={fileToImport}
        setFile={setFileToImport}
        fileName={fileNameToImport}
        setFileName={setFileNameToImport}
        rowsTable={rowsToImport}
        columnsTable={columnsToImport}
        fetchDataAndUpdateTable={() => fetchDataShifts(id)}
      />

      {modalVisibleAddClass && (
        <MuiModal
          title={t("Welcome.text147")}
          width={modalWidth}
          buttons={<ButtonsClass />}
          visible={modalVisibleAddClass}
          onClose={handleCloseModalAddClass}
        >
          {showAlertError && (
            <AlertComponent
              message={messageAlertError}
              handleClose={() => setShowAlertError(false)}
              typeAlert={typeAlertError}
            />
          )}
          {showAlert && (
            <AlertComponent
              message={messageAlert}
              handleClose={() => setShowAlert(false)}
              typeAlert={typeAlert}
            />
          )}
          <InputLabelC
            label={t("Welcome.text148")}
            inputType="text"
            inputwidth="97%"
            setValue={setName}
            value={name}
          />
          <InputLabelC
            label="Tipo de clasificación"
            inputType="select"
            selectwidth="100%"
            options={filteredOptionsClass}
            hdlOnChange={(selectedValue) => {
              setTypeClass(selectedValue);
            }}
            value={typeClass}
          />
        </MuiModal>
      )}
      {modalVisibleDelete && (
        <MuiModal
          title={t("Welcome.text153")}
          buttons={<ButtonDelete />}
          width={modalWidth}
          visible={modalVisibleDelete}
          onClose={handleClickTrashClose}
        >
          <Typography style={stylesAgent.typography}>
            ¿{t("Welcome.text156")}" {itemToDelete.name} " ?
          </Typography>
        </MuiModal>
      )}
      {/* Modal para actualizar región */}
      {modalVisibleUpdateRegion && (
        <MuiModal
          title="Editar Región"
          width={modalWidth}
          visible={modalVisibleUpdateRegion}
          onClose={handleCloseModalUpdateRegion}
          buttons={<ButtonsUpdateRegion />}
        >
          {showAlert && (
            <AlertComponent
              message={messageAlert}
              handleClose={() => setShowAlert(false)}
              typeAlert={typeAlert}
            />
          )}
          {showAlertError && (
            <AlertComponent
              message={messageAlertError}
              handleClose={() => setShowAlertError(false)}
              typeAlert={typeAlertError}
            />
          )}
          <InputLabelC
            label="Nombre de la Región"
            inputType="text"
            inputwidth="97%"
            value={nameRegion}
            setValue={setNameRegion}
            onTextChange={handleTextChangeNameRegion}
            disabled={!canUpdateRegion}
          />

          <InputLabelC
            label="Status"
            inputType="select"
            selectwidth="97%"
            options={optionsStatus}
            value={status}
            hdlOnChange={(value) => setStatus(value)}
            disabled={!canUpdateRegion}
          />
        </MuiModal>
      )}
      {modalVisibleAddRegion && (
        <MuiModal
          title="Agregar Región"
          width={modalWidth}
          visible={modalVisibleAddRegion}
          onClose={handleCloseModalAddRegion}
          buttons={<ButtonsAddRegion />}
        >
          {showAlert && (
            <AlertComponent
              message={messageAlert}
              handleClose={() => setShowAlert(false)}
              typeAlert="success"
            />
          )}

          {showAlertError && (
            <AlertComponent
              message={messageAlertError}
              handleClose={() => setShowAlertError(false)}
              typeAlert="error"
            />
          )}

          <InputLabelC
            label="Nombre de la Región"
            inputType="text"
            inputwidth="97%"
            value={nameRegion}
            setValue={setNameRegion}
            onTextChange={handleTextChangeNameRegion}
          />
        </MuiModal>
      )}

      {/* Modal para agregar encuestas */}
      {modalVisibleAddSurvey && (
        <MuiModal
          title="Agregar Encuesta"
          width="800px"
          visible={modalVisibleAddSurvey}
          onClose={handleCloseModalAddSurvey}
          buttons={
            <div style={stylesAgent.divButton}>
              <ButtonComponent
                label="Crear Encuesta"
                onClick={handleCreateSurvey}
                backgroundColor="#9a2edb"
                color="white"
              />
            </div>
          }
        >
          {showAlert && (
            <AlertComponent
              message={messageAlert}
              handleClose={() => setShowAlert(false)}
              typeAlert={typeAlert}
            />
          )}
          {showAlertError && (
            <AlertComponent
              message={messageAlertError}
              handleClose={() => setShowAlertError(false)}
              typeAlert={typeAlertError}
            />
          )}

          {/* Nombre de la encuesta */}
          <InputLabelC
            label="Nombre de la Encuesta"
            inputType="text"
            inputwidth="90%"
            value={surveyName}
            setValue={setSurveyName}
            onTextChange={setSurveyName}
          />

          {/* Preguntas */}
          <div style={{ marginTop: "2rem" }}>
            <h3>Preguntas</h3>
            <Stack spacing={2}>
              {questions.map((question, qIndex) => (
                <div
                  key={qIndex}
                  style={{
                    border: "1px solid #ddd",
                    padding: "1rem",
                    borderRadius: "4px",
                  }}
                >
                  <Stack spacing={1}>
                    {/* Texto de la pregunta */}
                    <InputLabelC
                      label={`Pregunta ${qIndex + 1}`}
                      inputType="text"
                      inputwidth="90%"
                      value={question.text}
                      setValue={(text) =>
                        handleQuestionChange(qIndex, "text", text)
                      }
                      onTextChange={(text) =>
                        handleQuestionChange(qIndex, "text", text)
                      }
                    />

                    {/* Tipo de pregunta */}
                    <InputLabelC
                      label="Tipo de Pregunta"
                      inputType="select"
                      inputwidth="90%"
                      options={[
                        { label: "Opción Múltiple", value: "options" },
                        { label: "Pregunta Abierta", value: "text" },
                      ]}
                      value={question.type}
                      hdlOnChange={(type) =>
                        handleQuestionChange(qIndex, "type", type)
                      }
                    />

                    {/* Opciones (solo si es de tipo options) */}
                    {question.type === "options" && (
                      <div>
                        <label
                          style={{
                            color: "#708198",
                            fontWeight: 600,
                            fontFamily: "Raleway, sans-serif",
                            display: "block",
                            marginBottom: "0.5rem",
                          }}
                        >
                          Opciones
                        </label>
                        <Stack spacing={1}>
                          {question.options.map((option, oIndex) => (
                            <div
                              key={oIndex}
                              style={{
                                display: "flex",
                                gap: "0.5rem",
                                alignItems: "flex-end",
                              }}
                            >
                              <InputLabelC
                                label={`Opción ${oIndex + 1}`}
                                inputType="text"
                                value={option}
                                setValue={(val) =>
                                  handleOptionChange(qIndex, oIndex, val)
                                }
                                onTextChange={(val) =>
                                  handleOptionChange(qIndex, oIndex, val)
                                }
                                inputwidth="100%"
                              />
                              <ButtonComponent
                                label="Eliminar"
                                onClick={() =>
                                  handleRemoveOption(qIndex, oIndex)
                                }
                                backgroundColor="#f44336"
                                color="white"
                                width="100px"
                              />
                            </div>
                          ))}
                        </Stack>
                        <div style={{ marginTop: "0.5rem" }}>
                          <ButtonComponent
                            label=" + Agregar Opción"
                            onClick={() => handleAddOption(qIndex)}
                            backgroundColor="#4CAF50"
                            color="white"
                            width="100px"
                          />
                        </div>
                      </div>
                    )}

                    {/* Botón para eliminar pregunta */}
                    <ButtonComponent
                      label="Eliminar Pregunta"
                      onClick={() => handleRemoveQuestion(qIndex)}
                      backgroundColor="#ff9800"
                      color="white"
                      width="100px"
                    />
                  </Stack>
                </div>
              ))}
            </Stack>

            {/* Botón para agregar pregunta */}
            <div alignItems="flex-start" style={{ marginTop: "1rem" }}>
              <ButtonComponent
                label="+ Agregar Pregunta"
                onClick={handleAddQuestion}
                backgroundColor="#2196F3"
                color="white"
                width="100 px"
              />
            </div>
          </div>
        </MuiModal>
      )}

      {modalViewSurvey && selectedSurvey && (
        <MuiModal
          title={`Encuesta: ${selectedSurvey.name}`}
          width="600px"
          visible={modalViewSurvey}
          onClose={() => setModalViewSurvey(false)}
          buttons={
            <div style={stylesAgent.divButton}>
              {!isEditingSurv && (
                <ButtonComponent
                  label="Editar"
                  onClick={() => setIsEditingSurv(true)}
                  backgroundColor="#1976d2"
                  color="white"
                />
              )}

              {isEditingSurv && (
                <ButtonComponent
                  label="Guardar Cambios"
                  onClick={handleUpdateSurvey}
                  backgroundColor="#4CAF50"
                  color="white"
                />
              )}
            </div>
          }
        >
          <Stack spacing={2}>
            {questions
              .filter((q) => !q.isDeleted)
              .map((q, index) => (
                <div
                  key={q._id || q.id}
                  style={{
                    border: "1px solid #e0e0e0",
                    padding: "1.2rem",
                    borderRadius: "8px",
                    backgroundColor: "#fafafa",
                  }}
                >
                  <div style={{ marginBottom: "0.5rem" }}>
                    {isEditingSurv ? (
                      <div>
                        <InputLabelC
                          label={`Pregunta ${index + 1}`}
                          inputType="text"
                          value={q.text}
                          setValue={(val) =>
                            handleQuestionChange(index, "text", val)
                          }
                          onTextChange={(val) =>
                            handleQuestionChange(index, "text", val)
                          }
                          inputwidth="90%"
                        />
                        <div style={{ marginTop: "0.5rem" }}>
                          <ButtonComponent
                            label="Eliminar Pregunta"
                            onClick={() => handleRemoveQuestion(index)}
                            backgroundColor="#f44336"
                            color="white"
                            width="100px"
                          />
                        </div>
                      </div>
                    ) : (
                      <strong>
                        {index + 1}. {q.text}
                      </strong>
                    )}
                  </div>
                  {isEditingSurv && (
                    <div style={{ marginBottom: "1rem" }}>
                      <InputLabelC
                        label="Tipo de Pregunta"
                        inputType="select"
                        selectwidth="95%"
                        options={[
                          { label: "Opción múltiple", value: "options" },
                          { label: "Respuesta abierta", value: "text" },
                        ]}
                        value={q.type}
                        hdlOnChange={(type) =>
                          handleQuestionChange(index, "type", type)
                        }
                      />
                    </div>
                  )}

                  <Typography
                    variant="caption"
                    color="textSecondary"
                    style={{ display: "block", marginBottom: "0.5rem" }}
                  >
                    {q.type === "options"
                      ? "Opción múltiple"
                      : "Respuesta abierta"}
                    {q.type === "options" && (
                      <Stack spacing={1} style={{ marginTop: "0.5rem" }}>
                        {q.options.map((opt, i) => (
                          <div
                            key={i}
                            style={{
                              display: "flex",
                              gap: "0.5rem",
                              alignItems: "center",
                            }}
                          >
                            {isEditingSurv ? (
                              <>
                                <InputLabelC
                                  label={`Opción ${i + 1}`}
                                  inputType="text"
                                  value={opt}
                                  setValue={(val) =>
                                    handleOptionChange(index, i, val)
                                  }
                                  onTextChange={(val) =>
                                    handleOptionChange(index, i, val)
                                  }
                                  inputwidth="95%"
                                />
                                <ButtonComponent
                                  label="X"
                                  onClick={() => handleRemoveOption(index, i)}
                                  backgroundColor="#f44336"
                                  color="white"
                                  width="50px"
                                />
                              </>
                            ) : (
                              <>• {opt}</>
                            )}
                          </div>
                        ))}

                        {/* ➕ Agregar opción */}
                        {isEditingSurv && (
                          <div style={{ marginTop: "0.5rem" }}>
                            <ButtonComponent
                              label="+ Agregar Opción"
                              onClick={() => handleAddOption(index)}
                              backgroundColor="#4CAF50"
                              color="white"
                              width="100px"
                            />
                          </div>
                        )}
                      </Stack>
                    )}
                  </Typography>
                </div>
              ))}
            {isEditingSurv && (
              <div alignItems="flex-start" style={{ marginTop: "1rem" }}>
                <ButtonComponent
                  label="+ Agregar Pregunta"
                  onClick={handleAddQuestion}
                  backgroundColor="#2196F3"
                  color="white"
                  width="25%"
                />
              </div>
            )}
          </Stack>
        </MuiModal>
      )}

      {modalVisibleAddShift && (
        <MuiModal
          title="Agregar Turno"
          width="600px"
          buttons={<ButtonsShifts />}
          visible={modalVisibleAddShift}
          onClose={() => setModalVisibleAddShift(false)}
        >
          {showAlert && (
            <AlertComponent
              message={messageAlert}
              handleClose={() => setShowAlert(false)}
              typeAlert={typeAlert}
            />
          )}
          {showAlertError && (
            <AlertComponent
              message={messageAlertError}
              handleClose={() => setShowAlertError(false)}
              typeAlert={typeAlertError}
            />
          )}

          <InputLabelC
            label="Nombre del Turno"
            inputType="text"
            inputwidth="97%"
            value={nameShift}
            setValue={setNameShift}
          />
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "1rem",
              marginBottom: "1rem",
            }}
            style={{ marginTop: "1rem" }}
          >
            <InputTime
              label="Hora de inicio"
              minuteStep={30}
              startHour={0}
              endHour={23}
              width="45%"
              value={startTime}
              setValue={setStartTime}
            />
            <InputTime
              label="Hora de Salida"
              minuteStep={30}
              startHour={0}
              endHour={23}
              width="45%"
              value={endTime}
              setValue={setEndTime}
            />
          </Stack>

          <InputCheckboxes
            label="Días de la semana"
            options={[
              { label: "Lunes", value: "MONDAY" },
              { label: "Martes", value: "TUESDAY" },
              { label: "Miércoles", value: "WEDNESDAY" },
              { label: "Jueves", value: "THURSDAY" },
              { label: "Viernes", value: "FRIDAY" },
              { label: "Sábado", value: "SATURDAY" },
              { label: "Domingo", value: "SUNDAY" },
            ]}
            value={shiftsDays}
            setValue={setShiftsDays}
            direction="horizontal"
          />
        </MuiModal>
      )}

      {modalVisibleEditShift && (
        <MuiModal
          title={"Editar Turno"}
          buttons={<ButtonsEdiShifts />}
          width="700px"
          visible={modalVisibleEditShift}
          onClose={handleCloseModalShifts}
        >
          <Stack>
            {showAlertError && (
              <AlertComponent
                message={messageAlertError}
                handleClose={() => setShowAlertError(false)}
                typeAlert={typeAlertError}
              />
            )}
            {showAlert && (
              <AlertComponent
                message={messageAlert}
                handleClose={() => setShowAlert(false)}
                typeAlert={typeAlert}
              />
            )}

            <InputLabelC
              label="Nombre del Turno"
              inputType="text"
              inputwidth="97%"
              value={nameShift}
              setValue={setNameShift}
            />
            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: "space-evenly",
                alignItems: "center",
                marginTop: "1rem",
                marginBottom: "1rem",
              }}
              style={{ marginTop: "1rem" }}
            >
              <InputTime
                label="Hora de inicio"
                minuteStep={30}
                startHour={0}
                endHour={23}
                width="45%"
                value={startTime}
                setValue={setStartTime}
              />
              <InputTime
                label="Hora de Salida"
                minuteStep={30}
                startHour={0}
                endHour={23}
                width="45%"
                value={endTime}
                setValue={setEndTime}
              />
            </Stack>

            <InputCheckboxes
              label="Días de la semana"
              options={[
                { label: "Lunes", value: "MONDAY" },
                { label: "Martes", value: "TUESDAY" },
                { label: "Miércoles", value: "WEDNESDAY" },
                { label: "Jueves", value: "THURSDAY" },
                { label: "Viernes", value: "FRIDAY" },
                { label: "Sábado", value: "SATURDAY" },
                { label: "Domingo", value: "SUNDAY" },
              ]}
              value={shiftsDays}
              setValue={setShiftsDays}
              direction="horizontal"
            />
          </Stack>
        </MuiModal>
      )}
    </Stack>
  );
}

export default Servicios;
